"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    first_set: [
        {
            label: "FF 91",
            url: "/ff-91",
            subnav: [
                {
                    url: "/ff-91#design",
                    label: "Design"
                },
                {
                    url: "/ff-91#performance",
                    label: "Performance"
                },
                {
                    url: "/ff-91#technology",
                    label: "Technology"
                },
                {
                    url: "/ff-91#interior",
                    label: "Interior"
                }
            ]
        },
        {
            label: "DESIGN YOURS",
            url: "/futuresight"
        },
        {
            label: "APP",
            url: "/mobile-app"
        },
        {
            label: "INVESTORS",
            url: "https://investors.ff.com/"
        },
    ],
    second_set: [
        {
            label: "SIGN IN",
            url: "/account",
            loggedInLabel: "My FF"
        }
    ],
    hero_button: {
        label: "PREORDER YOURS",
        url: "/reserve",
    },
    logo_link: "/us",
    color_theme: "LIGHT",
    scroll_effect: true
};
exports.default = defaultProps;
